module.exports = __webpack_public_path__ + "static/enterprise-9ba6c9af36b281fbe9073854b108169e.png";